export const isReport = (caseData: any) => caseData?.productType === 'REPORT';
